import colors from '../../colors';

const globalHeader = {
  colors: {
    backgroundColor: colors.primary.white,
    brand: colors.primary.black,
    link: colors.primary.darkGrey,
    mobileLink: colors.primary.darkGrey,
    mobileLinkBackground: colors.primary.white,
    navbarToggler: colors.primary.dkBlue1,
    border: colors.accent.ltGrey3,
    braze: colors.primary.primary,
  },
};

export default globalHeader;
